import { atom } from 'jotai';

export const allTableAtom = atom([]);